// const baseUrl = "http://84.247.181.60:2000/api";
const baseUrl = "https://api.tripsecuregh.com/api";

const Config = {
  apiUrl: baseUrl,

  // Payment Methods
  MTN_PAYMENT: "MTN",
  TELECEL_PAYMENT: "TELECEL",
  AIRTEL_TIGO_PAYMENT: "AT",

  // Portal URLs
  PROVIDER_PORTAL_URL: "https://provider.tripsecuregh.com",
  AGENT_PORTAL_URL: "https://agent.tripsecuregh.com",
};

export default Config;
